module.exports = __webpack_public_path__ + "static/media/p1.ab08e3a8.png";